/**
 * The one seam for `blob:` object URLs, shared by every package, so minting
 * and releasing them never scatters and tests can swap it out. Whoever holds
 * a URL revokes it once nothing shows it any more.
 */

export function createObjectUrl(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function revokeObjectUrl(url: string): void {
  URL.revokeObjectURL(url);
}
